import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const OverloadSettingPage = () => {
  return(
    <HomeUI />
  )
}

export default OverloadSettingPage;
